// extracted by mini-css-extract-plugin
export default {"button":"AdminsList_button__fJLbj"};